module.exports = __webpack_public_path__ + "static/media/2009.24737111.png";